import Link from 'next/link';

export interface PendingBackendScreenProps {
  feature: string;
  details?: string;
}

export function PendingBackendScreen({ feature, details }: PendingBackendScreenProps) {
  return (
    <div
      role="status"
      data-testid="pre-inspection-pending-backend"
      className="flex min-h-[40vh] items-center justify-center px-6 py-12"
    >
      <div className="max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
          <span className="text-sm font-semibold uppercase text-amber-700" aria-hidden="true">
            Soon
          </span>
        </div>
        <h2 className="text-lg font-semibold text-gray-900">
          {feature} backend endpoint not yet deployed
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          {details ??
            'This screen is waiting on the corresponding backend route to ship. Create is available today; list and detail go live once the GET endpoints are deployed.'}
        </p>
        <Link
          href="/pre-inspections/new"
          className="mt-6 inline-flex items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700"
        >
          Create a Pre-Inspection
        </Link>
      </div>
    </div>
  );
}
